import { render } from "./PersonalizedCourse.vue?vue&type=template&id=6c29141a&scoped=true"
import script from "./PersonalizedCourse.vue?vue&type=script&lang=js"
export * from "./PersonalizedCourse.vue?vue&type=script&lang=js"

import "./PersonalizedCourse.vue?vue&type=style&index=0&id=6c29141a&scoped=true&lang=css"

import exportComponent from "/Users/sophiasharif/Desktop/projects/i-hate-pinia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c29141a"]])

export default __exports__